"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenApiDiscriminator = void 0;
const utils_1 = require("@dev-stream/utils");
class OpenApiDiscriminator extends utils_1.BaseModel {
    constructor() {
        super(...arguments);
        this.BASE_TYPE = OpenApiDiscriminator;
    }
    GetDefaultValue() {
        return {
            propertyName: "",
        };
    }
}
exports.OpenApiDiscriminator = OpenApiDiscriminator;
